import { render, staticRenderFns } from "./Voyageur.vue?vue&type=template&id=2348829c&"
import script from "./Voyageur.vue?vue&type=script&lang=js&"
export * from "./Voyageur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports